module.exports = __webpack_public_path__ + "static/media/orangeTheme-boy.55908350.svg";